import React from 'react';
import { Auth } from 'aws-amplify';
import { RouteComponentProps } from 'react-router';
import { Redirect } from 'react-router-dom';
import { APP_NAME } from 'aws-exports';

const LogoutScreen = () => {
	Auth.signOut();
	document.title = `${APP_NAME} — Logout`;
	return <Redirect push={true} to="/login" />;
};
export default LogoutScreen;
